import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CountyStoreState } from "../types/county";
import { SearchDefaultValue, SearchValue } from "./types";

const initialState: CountyStoreState = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const county = createSlice({
  name: "county",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = county.actions;

export const selectSearchValue = (state: { county: CountyStoreState }) =>
  state?.county?.searchValue;
export const selectIsActive = (state: { county: CountyStoreState }) =>
  state?.county?.isActive;

export default county.reducer;
